export default __webpack_public_path__ + "static/media/tim.ce68b7ac.jpg";